import * as FileSaver from 'file-saver';
import { Button } from 'antd';


import * as XLSX from 'xlsx'


const keyValue = {
    id: 'ID',
    cpf: 'CPF',
    nome: "NOME",
    rg: "RG",
    estadoRg:"UF",
    dataNascimento: "DATA NASCIMENTO",
    orgaoExpedidor: "ORGÃO EXPEDITOR",
    cidade: "CIDADE",
    email: "E-MAIL",
    telefone: "TELEFONE",
    curso: "CURSO",
    semestre: "SEMESTRE",
    instituicao: "INSTITUIÇÃO",
    turnoCurso: "TURNO CURSO",
    turnoDisponibilidade: "TURNO DISPONIBILIDADE",
    deficiente: "DEFICIENTE",
    situacao: "SITUAÇÃO"
}


export const ExportCSV = ({ csvData, fileName }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        // DEIXAR COLUNAS UPPERCASE
        var range = XLSX.utils.decode_range(ws['!ref']);
        for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            //ws[address].v = ws[address].v.toUpperCase();
            ws[address].v = keyValue[ws[address].v] ?  keyValue[ws[address].v] : '';
        }
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return (
        //   <ButtonExport>
        <div className="areaButton">
            <Button onClick={(e) => exportToCSV(csvData, fileName)}>Exportar Consulta </Button>
        </div>
        //   </ButtonExport>
    )

}